import { render, staticRenderFns } from "./businessDetailGroup.vue?vue&type=template&id=40209912&scoped=true"
import script from "./businessDetailGroup.vue?vue&type=script&lang=js"
export * from "./businessDetailGroup.vue?vue&type=script&lang=js"
import style0 from "./businessDetailGroup.vue?vue&type=style&index=0&id=40209912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40209912",
  null
  
)

export default component.exports